import { createEnumHelper } from '@seiue/util'

import { QuestionTypeEnum } from 'packages/sdks-next/growp'

export const questionTypeEnumToLabel = createEnumHelper(() => ({
  [QuestionTypeEnum.SingleChoice]: '单选',
  [QuestionTypeEnum.MultipleChoice]: '多选',
  [QuestionTypeEnum.FillInBlank]: '填空',
  [QuestionTypeEnum.ShortAnswer]: '简答',
  [QuestionTypeEnum.TrueOrFalse]: '判断',
  [QuestionTypeEnum.Product]: '复合',
}))
